var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWinter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.417,
    transform: "translate(8 5)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 35.427,
    x2: 35.427,
    y1: 77
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "47.671 4.68 35.426 16.916 23.19 4.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23.185 72.488 35.427 60.252 47.669 72.488"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.785,
    x2: 2.068,
    y1: 57.752,
    y2: 19.25
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.244 10.992 16.722 27.71 .002 32.186"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "58.755 66.093 54.273 49.378 71 44.895"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.788,
    x2: 2.071,
    y1: 19.252,
    y2: 57.753
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "0 44.813 16.727 49.293 12.245 66.008"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "70.999 32.105 54.276 27.625 58.754 10.907"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinter);
export default __webpack_public_path__ + "static/media/winter.72788d54.svg";
export { ForwardRef as ReactComponent };